<template>
    <div class="container">
        <div class="row ">
            <router-link to="/trends" active-class="active">
                <img v-if="selected === 'trends'" src="./../assets/images/trends-active.svg" >
                <img v-else  src="./../assets/images/trends.svg">
            </router-link>
            <router-link to="/konto" active-class="active">
                <img v-if="selected === 'konto'" src="./../assets/images/konto-active.svg" >
                <img v-else  src="./../assets/images/konto.svg">
            </router-link>
            <router-link to="/deals" active-class="active">
                <img v-if="selected === 'deals'" src="./../assets/images/deals-active.svg" >
                <img v-else  src="./../assets/images/deals.svg">
            </router-link>
            <router-link to="/produkte" active-class="active">
                <img v-if="selected === 'produkte'" src="./../assets/images/produkte-active.svg" >
                <img v-else  src="./../assets/images/produkte.svg">
            </router-link>
            <router-link to="/profil" active-class="active">
                <img v-if="selected === 'profil'" src="./../assets/images/profil-active.svg" >
                <img v-else  src="./../assets/images/profil.svg">
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
      data() {
        return {
          selected: this.$route.name
        }
      }
    }
</script>

<style lang="scss" scoped>
    @import '../styles/app';
    .container {
        background-color: white;
        bottom: 0;
        width: 100%;
        border-top: 1px solid $color-list-border;
        padding: 0 !important;
        img {
            padding: 8px 3px 5px;
        }
        position: fixed;
        left: 0;
    }
</style>
